class Content {
  constructor (id, key, text) {
    this.id = id
    this.key = key
    this.text = text
  }
}

export default Content
